import { request } from "../base";

export interface SearchRebuildStats {
	rebuilt: Record<
		string,
		{ documents: number; size: string }
	>;
	timestamp: string;
}

export const adminSearchApi = {
	rebuildIndex(type?: string) {
		const params = type ? `?type=${type}` : "";
		return request<SearchRebuildStats>(
			`/api/admin/search/rebuild${params}`,
			{ method: "POST" },
		);
	},
};
